import gql from 'graphql-tag';

export const EditorialSectionListQuery = gql`
	query EditorialSectionListQuery(
		$first: Int
		$cursor: String
		$orderBy: EditorialSectionOrderBy
		$orderDesc: Boolean
		$filter: EditorialSectionFilterInput
	) {
		entities: editorialSections(
			first: $first
			after: $cursor
			orderBy: $orderBy
			orderDesc: $orderDesc
			filter: $filter
		) {
			edges {
				node {
					id
					localId
					name
					Parent {
						id
						name
					}
					editorialBrand
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;


